import { find, register } from '../../../../Javascript/Sysmex/Utils'

const Maps = el => {
  const componentPrefix = el.dataset.componentprefix
  const mapContainer = find(`.${componentPrefix}mapContainer`, el)
  const items = JSON.parse(el.dataset.items)
  const apiKey = el.dataset.apikey
  const zoomLevel = parseInt(el.dataset.zoom)
  const hasRouteFunction = el.dataset.routefunction
  const language = el.dataset.language

  function loadScript (src) {
    return new Promise(function (resolve, reject) {
      const script = document.createElement('script')
      script.src = src
      script.onload = resolve
      script.onerror = resolve
      document.body.appendChild(script)
    })
  }

  function initMap () {
    const google = window.google

    const map = new google.maps.Map(mapContainer, {
      zoom: zoomLevel,
      center: { lat: 53.664145, lng: 9.9823243 },
      streetViewControl: false
    })

    if (hasRouteFunction) {
      initRouter()
    } else {
      const bounds = new google.maps.LatLngBounds()

      items.forEach(item => {
        const latitude = parseFloat(item.lat)
        const longitude = parseFloat(item.long)
        bounds.extend({ lat: latitude, lng: longitude })

        new google.maps.Marker({ // eslint-disable-line no-new
          position: { lat: latitude, lng: longitude },
          map: map,
          title: item.label
        })
      })

      if (items.length > 1) {
        map.fitBounds(bounds)
      } else {
        map.setCenter({ lat: parseFloat(items[0].lat), lng: parseFloat(items[0].long) })
      }
    }

    function initRouter () {
      const origin = find(`.${componentPrefix}routeFrom`, el)
      const destination = find(`.${componentPrefix}routeTo`, el)
      const calcBtn = find(`.${componentPrefix}routeCalc`, el)
      const clearBtn = find(`.${componentPrefix}routeClear`, el)
      const mapsBtn = find(`.${componentPrefix}externalLink`, el)
      const directionsDisplay = new google.maps.DirectionsRenderer({ draggable: true })
      const directionsService = new google.maps.DirectionsService()
      const geocoder = new google.maps.Geocoder()
      google.maps.InfoWindow.prototype.opened = false
      const infoWindow = new google.maps.InfoWindow()

      getUserLocation()

      directionsDisplay.setMap(map)
      directionsDisplay.setPanel(find(`.${componentPrefix}directions`, el))

      origin.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          calcRoute(origin.value)
        }
      })
      calcBtn.addEventListener('click', () => calcRoute(origin.value))
      clearBtn.addEventListener('click', clearRoute)

      function calcRoute (orig) {
        calcBtn.style.display = 'none'
        clearBtn.style.display = 'block'
        mapsBtn.style.display = 'block'

        if (infoWindow.opened) {
          infoWindow.close()
          infoWindow.opened = false
        }

        const request = {
          origin: orig,
          destination: destination.value,
          /* eslint-disable */
          travelMode: google.maps.TravelMode['DRIVING']
          /* eslint-enable */
        }

        directionsService.route(request, function (response, status) {
          if (status === google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response)
          }
        })

        const url = 'https://www.google.com/maps/dir/?api=1&origin=' + origin.value + '&destination=' + request.destination + '&travelmode=driving'
        mapsBtn.href = url.replace(/\s/g, '+')
      }

      function clearRoute () {
        clearBtn.style.display = 'none'
        calcBtn.style.display = 'block'
        mapsBtn.style.display = 'none'
        directionsDisplay.set('directions', null)
      }

      function getUserLocation () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
              calcRoute(pos)
              geocodeLocation(pos)
            },
            () => {
              handleLocationError(true, infoWindow, map.getCenter())
            }
          )
        } else {
          handleLocationError(false, infoWindow, map.getCenter())
        }
      }

      function geocodeLocation (loc) {
        geocoder.geocode({ location: loc }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              origin.value = results[0].formatted_address
              infoWindow.setPosition(loc)
              infoWindow.setContent(results[0].formatted_address)
              infoWindow.open(map)
              infoWindow.opened = true

              const url = 'https://www.google.com/maps/dir/?api=1&origin=' + origin.value + '&destination=' + destination.value + '&travelmode=driving'
              mapsBtn.href = url.replace(/\s/g, '+')
            } else {
              infoWindow.setContent('<strong>Your current location could not be matched with any real address.</strong><br/><br/>Please allow location services in the browser or enter<br/>a departure address in the top left input field.')
            }
          } else {
            infoWindow.setContent('Geocoder failed due to: ' + status)
          }
        })
      }

      function handleLocationError (browserHasGeolocation, infoWindow, pos) {
        infoWindow.setPosition(pos)
        infoWindow.setContent(
          browserHasGeolocation
            ? '<strong>Geolocation deactivated</strong><br/><br/>Please allow location services in the browser or enter<br/>a departure address in the top left input field.'
            : '<strong>Your browser doesnt support location services</strong><br/><br/>Please allow location services in the browser or enter<br/>a departure address in the top left input field.'
        )
        infoWindow.open(map)
        infoWindow.opened = true
      }
    }

    /*
    function capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
    */
  }
  loadScript(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=${language}`).then(initMap)
}

register('Maps', Maps)
